import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class UuidService {
	constructor() {}

	generate(): string {
		return this.randomLetter() + this.randomString(31);
	}

	private randomLetter(): string {
		const characters = 'abcdefghijklmnopqrstuvwxyz';
		const charactersLength: number = characters.length;
		return characters.charAt(Math.floor(Math.random() * charactersLength));
	}

	private randomCharacter(): string {
		const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPRRSTUVWXYZ0123456789';
		const charactersLength: number = characters.length;
		return characters.charAt(Math.floor(Math.random() * charactersLength));
	}

	private randomString(length = 32): string {
		let string = '';
		for (let i: number = length; i > 0; i--) {
			string += this.randomCharacter();
		}
		return string;
	}
}
